import { AddComment, Delete, Forum, HowToVote } from '@mui/icons-material'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@mui/material'
import { PaperComponent } from '../Helpers/Drag'
import { useNavigate } from 'react-router-dom'
import Examples from './Helpers/Examples'

const InfoDialog = ({ showInfo, setShowInfo, showSpecificSection }) => {
  const navigate = useNavigate()
  return (
    <Dialog
      open={showInfo}
      onClose={() => setShowInfo(false)}
      fullWidth
      PaperComponent={PaperComponent}
      maxWidth='lg'
      aria-labelledby='draggable-dialog-title'
    >
      <DialogTitle style={{ cursor: 'move' }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            color: 'secondary.main'
          }}
        >
          <HowToVote />
          Interacting With a Pulse
        </Box>
      </DialogTitle>
      <DialogContent>
        <p>
          Sections use accordions to group related prompts together. Click on
          any section title to expand or collapse its contents. Inside each
          section, you'll see prompts.
          <br />
          <br />
          Pulse's can have groupings of sections. If a Pulse has groupings,
          you'll see a tab bar at the top of the Pulse. Each tab represents a
          section grouping. Click on a tab to view sections in that grouping or
          use the all tab to view all sections. If you are on the all tab,
          you'll see all of the sections and each section will have an icon with
          a tooltip to show the grouping title.
          <br />
          <br />
          Click on any image to view a larger version.
          <br />
          <br />
          <Examples showSpecificSection={showSpecificSection} />
          <b>
            After, you can add a comment to your response on your comment by
            clicking{' '}
            <AddComment sx={{ verticalAlign: 'bottom' }} color='primary' />.
          </b>
          <br />
          You can remove your response by clicking the delete button (
          <Delete color='error' sx={{ verticalAlign: 'bottom' }} />)
          <br />
          <br />
          <b>
            After responding, you'll be able to view overall results for that
            prompt by clicking{' '}
            <Forum color='primary' sx={{ verticalAlign: 'bottom' }} />.{' '}
          </b>
          Respond to as many or as few prompts as you like. Your responses
          contribute to the overall results, but you can skip any prompt that
          doesn't apply to you.
          <br />
          <br />
          If enabled, you can also see comments and questions from other
          participants. Filter responses by response option, all or just yours.
          <br />
        </p>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setShowInfo(false)
            navigate('/viewPulse/howtouse')
          }}
          color='secondary'
        >
          Example Pulse
        </Button>
        <Button onClick={() => setShowInfo(false)} variant='contained'>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default InfoDialog
